module.exports = __webpack_public_path__ + "assets/img/yxh.1474b268.png";